import { Checkbox, FormControl, FormControlLabel, FormHelperText, Stack } from '@mui/material';
import { xor } from 'lodash-es';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface WsCheckboxListProps {
  name: string;
  options: {
    [key: string]: string;
  };
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  required?: boolean;
  disabled?: boolean;
}

const WsCheckboxList = ({
  name,
  options,
  direction = 'column',
  required = false,
  disabled = false,
}: WsCheckboxListProps) => {
  const { control } = useFormContext();
  return (
    <FormControl fullWidth required={required} disabled={disabled}>
      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <Stack direction={direction}>
              {Object.keys(options).map((key) => (
                <FormControlLabel
                  key={key}
                  label={options[key]}
                  control={
                    <Checkbox
                      checked={value?.includes(key)}
                      onChange={() => onChange(xor(value, [key]))}
                    />
                  }
                />
              ))}
            </Stack>

            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};

export default WsCheckboxList;
